import React from "react";
import Link from "gatsby-link";
import PropTypes from "prop-types";
import Mailto from "react-mailto";

import EmailForm from "./../EmailForm/index.jsx";
import SocialIcons from "../SocialIcons/index.jsx";
import "./footer.css";

// eslint-disable-next-line one-var
const FooterLink = props => <li>
    <Link to={props.to}>{props.children}</Link>
  </li>;

FooterLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired
};

// eslint-disable-next-line one-var
const Footer = ({ siteMetadata }) => <footer>
    <EmailForm />
    <div className="sub">
      <div className="container">
        <div className="col-50 fr">
          <h6>
            <Mailto email={siteMetadata.email} obfuscate={false}>
              {siteMetadata.email}
            </Mailto>
          </h6>
        </div>
        <SocialIcons social={siteMetadata.social} />
        <div className="col-50">
          <h6>
            &copy; {new Date().getFullYear()} {siteMetadata.title} All rights
            reserved
          </h6>
        </div>
        <div className="cl" />
      </div>
    </div>
  </footer>;

Footer.propTypes = {
  siteMetadata: PropTypes.shape({
    title: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    social: PropTypes.shape({
      twitter: PropTypes.string.isRequired,
      linkedin: PropTypes.string.isRequired,
      github: PropTypes.string.isRequired
    })
  })
};
export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.jsx